import { createComponent } from '@mtfe/sweet';
import {
    lazyLoadImg,
    common,
    eventBus,
    dom,
    createObserve,
} from '@mtfe/sweet-utils';

import tpl from './dom.html';
import style from './style.less';
import componentUtils from '../utils/index';
import { COUPON_TYPE, COUPON_STATUS } from '../constants/index';
import RedPacketPoiBaseInfo from './RedPacketPoiBaseInfo/script';

const { createUniqueId } = common;
const { getGiftEventName } = componentUtils;

class RedBagWithPoiList {
    constructor(props) {
        this.props = props;
        this.RED_BAG_ID = createUniqueId();
        this.POI_LIST_ID = createUniqueId();
        this.MORE_TIP_ID = createUniqueId();
        this.BTN_ID = createUniqueId();
        this.ICON_ID = createUniqueId();
        this.component = this.createDom(props);
    }
    createDom(props) {
        try {
            const { redBagInfo, poiList, title, subtitle, recallBizId } = props;
            const { onCouponBtnClick, onMoreTipClick } = props;
            if (
                redBagInfo &&
                redBagInfo.giftInfo &&
                redBagInfo.giftInfo.type !== COUPON_TYPE.RED_BAG
            ) {
                console.warn('RedBagWithPoiList 无红包（商品券）');
                return '';
            }
            const { giftInfo } = redBagInfo;
            const { gift_id: giftId } = giftInfo;
            const isNewCoupon = giftInfo.status === COUPON_STATUS.STATUS_NEW;

            const data = {
                redBagInfo,
                isNewCoupon,
                POI_LIST_ID: this.POI_LIST_ID,
                MORE_TIP_ID: this.MORE_TIP_ID,
                ICON_ID: this.ICON_ID,
                BTN_ID: this.BTN_ID,
                RED_BAG_ID: this.RED_BAG_ID,
                listDom: this.createPoiListDom(poiList),
                title,
                subtitle,
            };

            const eventName = getGiftEventName(giftId);

            eventBus.$on(eventName, (newStatus) => {
                this.renderCoupon(newStatus);
            });
            const events = {
                onCouponBtnClick: () => {
                    onCouponBtnClick &&
                        onCouponBtnClick(redBagInfo, poiList, recallBizId);
                },
                onMoreTipClick: async () => {
                    const newList = await onMoreTipClick();
                    if (Array.isArray(newList) && newList.length > 0) {
                        this.appendPoiList(newList);
                    } else {
                        this.setListEnd();
                    }
                },
            };
            const component = createComponent(tpl, { data, style }, events);
            return component;
        } catch (error) {
            console.error(error);
            return '';
        }
    }
    getComponent() {
        return this.component;
    }
    createPoiListDom(newPoiList, isLoadMore = false) {
        const { onPoiInfoClick, poiList, redBagInfo, recallBizId } = this.props;
        const domList = newPoiList
            .map((poiInfo, index) => {
                return `<div class=${style.mb16}>${RedPacketPoiBaseInfo({
                    poiInfo,
                    onPoiInfoClick,
                    itemIndex: isLoadMore
                        ? poiList.length - newPoiList.length + index
                        : index,
                    isLazyLoadImg: !isLoadMore,
                    redBagInfo,
                    poiList,
                    recallBizId,
                })}</div>`;
            })
            .join('');

        return domList;
    }
    appendPoiList(newPoiList) {
        const listDomContainer = document.getElementById(this.POI_LIST_ID);
        const domList = this.createPoiListDom(newPoiList, true);
        if (listDomContainer && domList) {
            dom.appendDom(listDomContainer, domList);
        }
        this.ready();
    }
    setListEnd() {
        const moreTipDom = document.getElementById(this.MORE_TIP_ID);
        if (moreTipDom) {
            moreTipDom.innerText = '没有更多啦～';
        }
    }
    renderCoupon(newStatus) {
        const domBtn = document.getElementById(this.BTN_ID);
        const domIcon = document.getElementById(this.ICON_ID);
        if (domBtn && domIcon && newStatus === COUPON_STATUS.STATUS_RECEIVED) {
            domBtn.style.display = 'none';
            domIcon.style.display = 'block';
        }
    }
    ready() {
        const { onPoiObserver, onRedBagObserver, poiList, redBagInfo } =
            this.props;
        const couponDomList = Array.from(
            document.querySelectorAll(
                `#${this.POI_LIST_ID} [data-monitor-index]`,
            ),
        );
        const unObserveDomList = couponDomList.filter((item) => {
            const isObserver = item.getAttribute('on-observe');
            if (!isObserver) {
                item.setAttribute('on-observe', '1');
                return item;
            }
        });
        const redBagDom = document.getElementById(this.RED_BAG_ID);

        const observerCb = async (err, item) => {
            if (err) {
                return;
            }
            try {
                const currentIndex =
                    item.target.getAttribute('data-monitor-index');
                const currentPoiList = poiList;
                onPoiObserver && onPoiObserver(currentPoiList[currentIndex]);
            } catch (error) {
                console.error('商家曝光上报失败', error);
            }
        };
        const redBagObserverCb = async (err, item) => {
            if (err) {
                return;
            }
            try {
                onRedBagObserver && onRedBagObserver(redBagInfo);
            } catch (error) {
                console.error('红包曝光上报失败', error);
            }
        };
        if (couponDomList.length > 0) {
            createObserve(observerCb, unObserveDomList);
        }

        if (redBagDom) {
            createObserve(redBagObserverCb, [redBagDom]);
        }
    }
}

export default RedBagWithPoiList;
